import React, { useContext } from 'react'
import { useLocation } from '@reach/router'
import UserContext from '../../UserContext'
import { SaveEvent, ClickEvent } from './AnalyticsEvents'

type IdentifierWithCopyProps = {
    identifier?: string | number
}

let copySuccess:boolean | null = null

function copyText (idToCopy: string) {
    const field = document.getElementById(idToCopy)
    const iconField = field?.nextElementSibling

    if (field !== null) {
        window.getSelection()?.selectAllChildren(field)

        copySuccess = document.execCommand('copy')

        window.getSelection()?.removeAllRanges()
    }

    if (copySuccess === false) {
        if (iconField) iconField.className = 'far fa-thumbs-down'

        alert('Oops! That copy didn\'t work. Why don\'t you try it one more time.')
    } else if (copySuccess === true) {
        if (iconField) iconField.className = 'far fa-thumbs-up'
    }

    if (copySuccess !== null) {
        const timer = setTimeout(() => {
            if (iconField) iconField.className = 'far fa-clipboard'

            copySuccess = null
        }, 2000)

        return () => clearTimeout(timer)
    }
}

const IdentifierWithCopy: React.FC<IdentifierWithCopyProps> = ({ identifier }) => {
    const now = new Date()
    const user = useContext(UserContext)
    const { pathname } = useLocation()
    const idValue = 'identifier-to-copy-' + now.getTime().toString()
    const displayIdentifier = identifier?.toString().trim()

    return (
        <>
            { displayIdentifier && <p className='identifier-with-copy'><span className='emphasis'>ID#</span> <span className='identifer-to-copy' id={idValue}>{displayIdentifier}</span> <i className='far fa-clipboard' title='Copy ID to Clipboard' onClick={() => {SaveEvent(ClickEvent(user, pathname, 'Copy', displayIdentifier)); copyText(idValue)}}></i><i className="fas fa-print" title='Print this Page' onClick={() => {SaveEvent(ClickEvent(user, pathname, 'Print', displayIdentifier)); window.print()}}></i></p> }
        </>
    )
}

export default IdentifierWithCopy